module.exports = __webpack_public_path__ + "static/media/128x128.5fd207e6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/128x128.jpg
// module id = 80
// module chunks = 1